module.exports = __webpack_public_path__ + "img/testimonial-aycap.f99d2b64.png";